// removed by extract-text-webpack-plugin
module.exports = {"teamList":"_1yxP-gi6mgt9ApnAkjsmer","partnerItemImage":"_3DnxVdyPd4TMx7LC0x_F2Q","teamItemName":"sDMV-U_5IHhAsbHrfeFEV","teamItemPost":"_3xgjjoEB8jyxpS9jMGPu0L"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/team/team.css
// module id = 64
// module chunks = 0